import { FC } from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Spin } from 'antd';
import { useGlobalContext } from '@context';
import { useFacility } from '@common/hooks';
import { MainMenu } from '@unbooking/ui-modules';
import { ChecklistMenu, Driver, MobilityLogbook, Vehicle } from '@assets/svg/icons';
import { DriverLogo } from '@assets/svg/logos';
import './styles.scss';

const MobilityMenuPage: FC = () => {
  const navigate = useNavigate();
  const { agencyName } = useGlobalContext();
  const {
    facility: { city, country, linkMobilityLogbook, name },
    isLoading,
  } = useFacility();
  const { t } = useTranslation();

  const menuButtons = [
    {
      label: t('mobility.vehiclesChecklist'),
      className: 'btn-checklist',
      icon: <ChecklistMenu />,
      onClick: () => navigate('/mobility-management/vehicles-checklist'),
    },
    {
      label: t('mobility.myDrivers'),
      className: 'btn-my-drivers',
      icon: <Driver />,
      onClick: () => navigate('/mobility-management/driver-list'),
    },
    {
      label: t('mobility.myVehicles'),
      className: 'btn-my-vehicles',
      icon: <Vehicle />,
      onClick: () => navigate('/mobility-management/vehicle-list'),
    },
  ];

  if (linkMobilityLogbook)
    menuButtons.unshift({
      label: t('mobility.mobilityLogbook'),
      className: 'btn-logbook',
      icon: <MobilityLogbook />,
      onClick: () => navigate('/mobility-management/logbook'),
    });

  return (
    <MainMenu
      logo={isLoading ? <Spin className="spinner" size="large" spinning /> : <DriverLogo />}
      menuButtons={menuButtons}
      title={isLoading ? '' : `${name ? `${name}, ` : ''}${city}, ${country} | ${agencyName}`}
    />
  );
};

export default MobilityMenuPage;
